import type { ReactNode } from 'react';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { CTA } from '../CTA';
import { Arrow, ArrowWrapper, Content, Paragraph, Title } from './ModuleHeroStyles';

type ModuleHeroContentProps = {
  showArrow?: boolean;
  textColor: string;
  content: {
    title: string | ReactNode;
    paragraphMobile?: ReactNode;
    paragraphDesktop?: ReactNode;
  };
};

export const ModuleHeroContent = ({
  textColor,
  showArrow = false,
  content,
}: ModuleHeroContentProps) => {
  const { isDesktop } = useResponsiveVariant();
  return (
    <>
      <Content>
        {/* @ts-expect-error Typography is not typed yet */}
        <Title color={textColor} markupName="h1" upperCase variant="mono1">
          {content.title}
        </Title>

        {/* @ts-expect-error Typography is not typed yet */}
        <Paragraph color={textColor} markupName="p" variant="p1">
          {!isDesktop ? content.paragraphMobile : content.paragraphDesktop}
        </Paragraph>

        {!isDesktop && <CTA />}
      </Content>

      {showArrow && (
        <ArrowWrapper>
          <Arrow />
        </ArrowWrapper>
      )}
    </>
  );
};
